import { html } from "lit";
var icon_link_default = () => html`
  <svg stroke-fill viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m8.27 14.04-.78.81a3.75 3.75 0 0 1-5.38 0 3.97 3.97 0 0 1 0-5.53l4.03-4.15a3.75 3.75 0 0 1 5.16-.21 4 4 0 0 1 .6 5.28"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="m12.88 2.8.63-.65a3.75 3.75 0 0 1 6.2 1.27 4.01 4.01 0 0 1-.82 4.26l-4.03 4.15a3.75 3.75 0 0 1-5.16.21 4 4 0 0 1-.6-5.28"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
`;
export {
  icon_link_default as default
};
//# sourceMappingURL=icon-link.js.map
